<template>
    <div class="page">
        <div class="page-header">
            <!-- <div class="container"> -->
                <h1 class="pl-5 title text-light">Ofertas</h1>
            <!-- </div> -->
        </div>        
        <main>
            <div class="container">
                <!-- <condiciones/>                 -->
                <h2>No hay Ofertas disponibles en este momento</h2>
            </div>
        </main>
    </div>
</template>

<script>

//import condiciones from '@/components/condiciones.vue';

export default {
    name: 'ofertas',
    
    components: {            
        //condiciones,
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    mounted() {            

    },
    methods: {        

        //iconoStd(std) {                
            //return this.estados[std];
        //}
    }
}
</script>